import s from './GiftsStore.module.sass';

import React, { FC, useEffect, useMemo } from 'react';

import { Block, Header, InlineHeader, ScrollView } from '$uikit';
import { AuthPopoverState, GiftModel } from '$store/models';
import { useTranslator, useUserInfo } from '$hooks';
import { Loader, UserCell } from '$shared/components';
import { useDispatch, useSelector } from 'react-redux';
import { giftsActions, giftsSelector } from '$store/gifts';
import { GiftItem } from '$core/GiftsStore/GiftItem/GiftItem';
import { authSelector } from '$store/auth';
import { profileActions } from '$store/profile';

export const GiftsStore: FC<{ toId: number }> = ({ toId }) => {
  const { isLogged } = useSelector(authSelector);
  const dispatch = useDispatch();
  const user = useUserInfo(toId);
  const { gifts, specialTitle, specialIds, loadingStatus } = useSelector(giftsSelector);
  const t = useTranslator();

  useEffect(() => {
    dispatch(giftsActions.loadGifts(toId));
  }, [toId]);

  const specialGifts = useMemo(() => {
    const res: GiftModel[] = [];
    for (let gift of gifts) {
      if (specialIds.indexOf(gift.id) === -1) {
        continue;
      }

      res.push(gift);
    }

    return res;
  }, [specialIds, gifts]);

  const otherGifts = useMemo(() => {
    const res: GiftModel[] = [];
    for (let gift of gifts) {
      if (specialIds.indexOf(gift.id) > -1) {
        continue;
      }

      res.push(gift);
    }

    return res;
  }, [specialIds, gifts]);

  const handleSend = (gift: GiftModel) => {
    if (isLogged) {
      dispatch(
        giftsActions.showSend({
          toId,
          gift,
        }),
      );
    } else {
      dispatch(profileActions.setAuthPopoverState(AuthPopoverState.REGISTER));
    }
  };

  if (!user) {
    return <Loader isWrapped />;
  }

  return (
    <>
      <Header showBackButton>{t('chat_gift')}</Header>
      <ScrollView>
        <div className={s.wrap}>
          <Block>
            <UserCell objectId={toId} isFollowBtnShown={false} disabled />
          </Block>
        </div>
        {specialGifts.length > 0 && (
          <>
            <InlineHeader>{specialTitle}</InlineHeader>
            <div className={s.gifts}>
              {specialGifts.map((gift) => (
                <GiftItem
                  key={gift.id}
                  gift={gift}
                  onClick={() => {
                    handleSend(gift);
                  }}
                />
              ))}
            </div>
          </>
        )}
        <InlineHeader>{t('gift_store_title')}</InlineHeader>
        <div className={s.gifts}>
          {otherGifts.map((gift) => (
            <GiftItem
              key={gift.id}
              gift={gift}
              onClick={() => {
                handleSend(gift);
              }}
            />
          ))}
        </div>
      </ScrollView>
    </>
  );
};
